<template>
  <div v-show="isLoaded" class="mCContact_container" v-observe-visibility="startAnimate">
    <img class="mCContact_img" :src="banner" alt="Banner contacto">
    <img class="mCContact_img_mobile" :src="banner_mobile" alt="Banner contacto">
    <h1 class="mCContact_title" :class="{animate: animate}">Contáctanos</h1>
    <h3 class="mCContact_subtitle" :class="{animate: animate}">Si tienes alguna duda, comentario o sugerencia, puedes <br>
        contactarnos y nos comunicamos contigo lo antes posible
    </h3>
    <h3 class="mCContact_subtitle_mobile" :class="{animate: animate, onlySafari: isSafari}">Si tienes alguna duda, comentario <br> o sugerencia, puedes 
        contactarnos <br> y nos comunicamos contigo lo antes posible
    </h3>
    <div class="mCContact_logos" :class="{animate: animate}">
        <div class="mCContact_one">
            <img class="mCContact_cel" :src="logo_cel" alt="Telefono">
            <h3 class="mCContact_p_cel_mobile">Teléfono: <br> <span>+52 81 3586 3629</span></h3>
            <img class="mCContact_email" :src="logo_email" alt="Email">
            <h3 class="mCContact_p_email_mobile">Email: <br> <span>monterreypadeltour@gmail.com</span></h3>
            <img class="mCContact_instagram" :src="logo_instagram" alt="Instagram">
            <h3 class="mCContact_p_instagram_mobile">Instagram: <br> <span>monterreypadeltour</span></h3>
        </div>
        <div class="mCContact_two">
            <h3 class="mCContact_p_cel">Teléfono: <br> <span>+52 81 3586 3629</span></h3>
            <h3 class="mCContact_p_email">Email: <br> <span>monterreypadeltour@gmail.com</span></h3>
            <h3 class="mCContact_p_instagram">Instagram: <br> <span>monterreypadeltour</span></h3>
        </div>
    </div>
    <img class="mCContact_logo" :src="logo" alt="Banner MPT">
  </div>
</template>

<script>
import banner from "@/assets/contact_one_d.png";
import banner_mobile from "@/assets/contact_one_m.png";
import logo_cel from "@/assets/cel.png";
import logo_email from "@/assets/email.png";
import logo_instagram from "@/assets/instagram.png";
import logo from "@/assets/logo_MPT_black.png";
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "CContact",
    data() {
        return {
            animate: false,
            isSafari: false,
            banner,
            banner_mobile,
            logo_cel,
            logo_email,
            logo_instagram,
            logo,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {
        window.scrollTo(0,0)
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/CContact.scss";
</style>